module.exports = __webpack_public_path__ + "img/21.d7fbe09f.jpg";